module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sn-5d2dde7343ab4f2028909cf2ebe29186.svg";